import { PortalName } from 'commons/types/enums'
import { Keys, ReadHook, useStateManager } from 'state-manager'
import { heartbeat } from '~auth/service/user'

export const useHeartbeat: ReadHook<{ expires_at: string }, { portalName: PortalName }> = (opts) =>
  useStateManager().use(Keys.User.Session, () => heartbeat(opts as { portalName: PortalName }))
